import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const mainMenuStyles = makeStyles((theme: Theme) => ({
    mainMenu: {
        color: theme.palette.common.white,
        scrollbarWidth: "thin",
        margin: theme.spacing(0, 1),
        height: 240,
        flexGrow: 1,
        maxWidth: 400,
        overflowY: "auto",
        "& .MuiTreeItem-root": {
            "& .MuiTreeItem-content": {
                padding: 0,
                marginBottom: theme.spacing(0),
                "&.Mui-selected $itemLabel": {
                    background: `linear-gradient(90deg, #267895 0%, #1E5D76 100%)`,
                },
                "& .MuiTreeItem-iconContainer": {
                    display: "none",
                },
                "& .MuiTreeItem-label": {
                    padding: 0,
                },
            },
        },
        // Submenu container
        "& .MuiTreeItem-group": {
            marginLeft: 0,
            "& .MuiCollapse-wrapperInner > ul": {
                marginTop: theme.spacing(1),
                marginLeft: 0,
                padding: "1px",
                borderRadius: theme.spacing(0.5),
                boxShadow: "0px 2px 4px 0px #0000008C inset",
                background: theme.palette.button.active.from,
                // SubItems lines
                "& $indentedItem": {
                    "&:only-child $subItemIcon": {
                        "&::before, &::after": {
                            display: "none",
                        },
                    },
                    "&:first-child $subItemIcon": {
                        "&::before": {
                            display: "none",
                        },
                    },
                    "&:last-child $subItemIcon": {
                        "&::after": {
                            display: "none",
                        },
                    },
                },
            },
            "& .MuiTreeItem-root": {
                "& .MuiTreeItem-content": {
                    marginBottom: theme.spacing(0),
                    "&.Mui-selected $itemLabel": {
                        background: theme.palette.gradients.g03.n1,
                    },
                },
            },
        },
    },
    // Item (label and icons)
    itemLabel: {
        display: "flex",
        alignItems: "center",
        fontSize: 16,
        letterSpacing: 0.5,
        height: 40,
        padding: theme.spacing(0, 1.2),
        borderRadius: theme.spacing(0.5),
    },
    startIcon: {
        display: "flex",
        alignItems: "center",
        marginRight: theme.spacing(1),
    },
    endIcon: {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
    },
    expandIcon: {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
        "& svg": {
            fontSize: 12,
        },
    },
    // Items with left padding
    indentedItem: {
        "& $itemLabel": {
            paddingLeft: theme.spacing(3),
        },
        "& .Mui-selected $itemLabel": {
            background: `${theme.palette.gradients.g03.n1} !important`,
        },
    },
    // Items that shouldn't be clickable
    disabledItem: {
        opacity: 0.5,
        pointerEvents: "none",
    },
    // SubItem (the ones with the cirle on the left)
    subItemIcon: {
        width: 16,
        height: 16,
        borderRadius: 100,
        border: `1px solid ${theme.palette.common.white}`,
        marginRight: theme.spacing(1),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&::before, &::after": {
            content: "''",
            position: "absolute",
            height: 12,
            borderLeft: `1px solid ${theme.palette.common.white}`,
        },
        "&::before": {
            top: 0,
        },
        "&::after": {
            bottom: 0,
        },
    },
    subItemIconSelected: {
        width: 12,
        height: 12,
        borderRadius: 100,
        background: theme.palette.common.white,
    },
}));

export default mainMenuStyles;
